export const translationKeys = {
  // Main keys
  AUTOSPIN: 'AUTOSPIN',
  BET: 'BET',
  WIN: 'WIN',
  BALANCE: 'BALANCE',
  LAST_WIN: 'LAST_WIN',
  LAST_RESULTS: 'LAST_RESULTS',
  DEPOSIT: 'DEPOSIT',

  // Game controls
  PLAY: 'PLAY',
  PLAY_NOW: 'PLAY_NOW',
  PRESS_TO_START: 'PRESS_TO_START',
  PRESS_ANYWHERE_TO_CONTINUE: 'PRESS_ANYWHERE_TO_CONTINUE',
  SPIN: 'SPIN',

  // Bonus related
  BONUS: 'BONUS',
  BONUS_GAME: 'BONUS_GAME',
  BUY_BONUS: 'BUY_BONUS',
  BUY_BONUS_GAME: 'BUY_BONUS_GAME',
  BUY_BONUS_TICKET: 'BUY_BONUS_TICKET',
  PRE_BONUS_GAME: 'PRE_BONUS_GAME',
  FREE_SPINS: 'FREE_SPINS',
  MULTIPLIER: 'MULTIPLIER',
  RESPINS_LEFT: 'RESPINS_LEFT',

  // Bet related
  BET_AMOUNT: 'BET_AMOUNT',
  BET_TYPE: 'BET_TYPE',
  BET_HISTORY: 'BET_HISTORY',
  YOUR_BET: 'YOUR_BET',
  YOUR_BET_IS_ACCEPTED: 'YOUR_BET_IS_ACCEPTED',

  // Win related
  BIG_WIN: 'BIG_WIN',
  CONGRATULATIONS: 'CONGRATULATIONS',
  CONGRATULATIONS_YOU_HAVE_WON: 'CONGRATULATIONS_YOU_HAVE_WON',
  YOU_HAVE_WON: 'YOU_HAVE_WON',
  GOOD_LUCK: 'GOOD_LUCK',
  WIN_ODDS: 'WIN_ODDS',

  // Game info
  CRYSTAL_CRUSH: 'CRYSTAL_CRUSH',
  GAME_RULES: 'GAME_RULES',
  GAME_HISTORY: 'GAME_HISTORY',
  GAME_HISTORY_TIME: 'GAME_HISTORY_TIME',
  GAME_HISTORY_BET: 'GAME_HISTORY_BET',
  GAME_HISTORY_WIN: 'GAME_HISTORY_WIN',
  GAME_HISTORY_WIN_ODD: 'GAME_HISTORY_WIN_ODD',
  GAME_HISTORY_BONUS: 'GAME_HISTORY_BONUS',

  // Introduction
  INTRODUCTION_GAME_MAIN_TITLE: 'INTRODUCTION_GAME_MAIN_TITLE',
  ALL_THE_COLORS_ARE_WINNING: 'ALL_THE_COLORS_ARE_WINNING',

  // Crystal descriptions
  YELLOW_1_PIECES_ODDS_X60: 'YELLOW_1_PIECES_ODDS_X60',
  GREEN_12_PIECES_ODDS_X5: 'GREEN_12_PIECES_ODDS_X5',
  RED_20_PIECES_ODDS_X3: 'RED_20_PIECES_ODDS_X3',
  BLUE_30_PIECES_ODDS_X2: 'BLUE_30_PIECES_ODDS_X2',
  GOLD_1_ITEM_OPPORTUNITY_TO_PARTICIPATE_IN_THE_BONUS_GAME: 'GOLD_1_ITEM_OPPORTUNITY_TO_PARTICIPATE_IN_THE_BONUS_GAME',

  // Game descriptions
  CHOOSE_THE_COLOR_SPIN_THE_WHEEL_AND_MULTIPLY_YOUR_BET_BY_THE_GUESSED_ODDS_GOLD_CRYSTAL_WILL_GUARANTEE_FREE_BONUS_GAME_TICKET_WITH_YOUR_CURRENT_BET: 'CHOOSE_THE_COLOR_SPIN_THE_WHEEL_AND_MULTIPLY_YOUR_BET_BY_THE_GUESSED_ODDS_GOLD_CRYSTAL_WILL_GUARANTEE_FREE_BONUS_GAME_TICKET_WITH_YOUR_CURRENT_BET',
  COLLECT_FREE_SPINS_MULTIPLIERS_AND_CRYSTALS_IN_PRE_BONUS_GAME_TO_RAISE_YOUR_CHANCES_IN_BONUS_GAME: 'COLLECT_FREE_SPINS_MULTIPLIERS_AND_CRYSTALS_IN_PRE_BONUS_GAME_TO_RAISE_YOUR_CHANCES_IN_BONUS_GAME',
  GOLD_CRYSTAL_WILL_GUARANTEE_FREE_BONUS_GAME_TICKET_WITH_YOUR_CURRENT_BET: 'GOLD_CRYSTAL_WILL_GUARANTEE_FREE_BONUS_GAME_TICKET_WITH_YOUR_CURRENT_BET',
  DONT_WAIT_FOR_IT_BUY_IT_YOU_CAN_BUY_A_BONUS_GAME_TICKET_ANYTIME: 'DONT_WAIT_FOR_IT_BUY_IT_YOU_CAN_BUY_A_BONUS_GAME_TICKET_ANYTIME',
  YOU_CAN_BUY_A_BONUS_GAME_TICKET_ANY_TIME: 'YOU_CAN_BUY_A_BONUS_GAME_TICKET_ANY_TIME',
  WATCH_THE_BONUS_GAME_AND_ENJOY_YOUR_TIME: 'WATCH_THE_BONUS_GAME_AND_ENJOY_YOUR_TIME',

  // Game rules paragraphs
  THE_GAME_CONSISTS_OF_THE_BASIC_AND_BONUS_ROUNDS: 'THE_GAME_CONSISTS_OF_THE_BASIC_AND_BONUS_ROUNDS',
  THE_MAIN_SCENE_WHEEL_IS_DIVIDED_INTO_64_SECTORS_EACH_SECTOR_HAS_A_STONE_OF_DIFFERENT_COLORS_THAT_HAVE_FIXED_COEFFICIENTS_IN_PARTICULAR: 'THE_MAIN_SCENE_WHEEL_IS_DIVIDED_INTO_64_SECTORS_EACH_SECTOR_HAS_A_STONE_OF_DIFFERENT_COLORS_THAT_HAVE_FIXED_COEFFICIENTS_IN_PARTICULAR',
  TO_PARTICIPATE_IN_THE_GAME_THE_PLAYER_MUST_CHOOSE_ONE_OF_THE_4_COLORS_OFFERED_IN_THE_GAME_YELLOW_GREEN_RED_BLUE_AND_MAKE_A_PARTICIPATION_FEE_BET_WITHIN_THE_AMOUNT_OFFERED_BY_THE_ORGANIZER_AFTER_MAKING_THE_PAYMENT_AND_PRESSING_THE_SPIN_BUTTON_THE_WHEEL_WILL_START_SPINNING_AND_WILL_STOP_AT_ANY_RANDOM_COLOR_FROM_4_OFFERED_COLORS: 'TO_PARTICIPATE_IN_THE_GAME_THE_PLAYER_MUST_CHOOSE_ONE_OF_THE_4_COLORS_OFFERED_IN_THE_GAME_YELLOW_GREEN_RED_BLUE_AND_MAKE_A_PARTICIPATION_FEE_BET_WITHIN_THE_AMOUNT_OFFERED_BY_THE_ORGANIZER_AFTER_MAKING_THE_PAYMENT_AND_PRESSING_THE_SPIN_BUTTON_THE_WHEEL_WILL_START_SPINNING_AND_WILL_STOP_AT_ANY_RANDOM_COLOR_FROM_4_OFFERED_COLORS',
  THE_WINNERS_OF_THE_GAME_WILL_BE_THE_PLAYERS_WHO_CORRECTLY_GUESS_THE_COLOR_THAT_THE_WHEEL_WILL_STOP_ON_FOR_EXAMPLE_IF_THE_PLAYER_HAS_MADE_A_PARTICIPATION_FEE_BY_CHOOSING_THE_COLOR_GREEN_AND_THE_WHEEL_HAS_STOPPED_ON_THE_GREEN_COLOR_IN_THE_GAME_THE_PLAYER_WILL_BE_CONSIDERED_A_WINNER_AND_IF_THE_WHEEL_STOPS_ON_THE_RED_OR_ANY_COLOR_OTHER_THAN_GREEN_OR_GOLD_THE_PLAYERS_BET_WILL_BE_CONSIDERED_LOST: 'THE_WINNERS_OF_THE_GAME_WILL_BE_THE_PLAYERS_WHO_CORRECTLY_GUESS_THE_COLOR_THAT_THE_WHEEL_WILL_STOP_ON_FOR_EXAMPLE_IF_THE_PLAYER_HAS_MADE_A_PARTICIPATION_FEE_BY_CHOOSING_THE_COLOR_GREEN_AND_THE_WHEEL_HAS_STOPPED_ON_THE_GREEN_COLOR_IN_THE_GAME_THE_PLAYER_WILL_BE_CONSIDERED_A_WINNER_AND_IF_THE_WHEEL_STOPS_ON_THE_RED_OR_ANY_COLOR_OTHER_THAN_GREEN_OR_GOLD_THE_PLAYERS_BET_WILL_BE_CONSIDERED_LOST',
  THE_PAYOUT_IS_CALCULATED_BY_THE_PLAYERS_PARTICIPATION_FEE_BET_MULTIPLIED_BY_THE_CORRESPONDING_CORRECTLY_PREDICTED_ODDS_AND_IS_TRANSFERRED_TO_THE_PLAYERS_SPECIAL_GAME_ACCOUNT: 'THE_PAYOUT_IS_CALCULATED_BY_THE_PLAYERS_PARTICIPATION_FEE_BET_MULTIPLIED_BY_THE_CORRESPONDING_CORRECTLY_PREDICTED_ODDS_AND_IS_TRANSFERRED_TO_THE_PLAYERS_SPECIAL_GAME_ACCOUNT',
  IF_THE_WHEEL_STOPS_ON_A_GOLDEN_STONE_THE_PLAYER_GETS_A_CHANCE_TO_MOVE_TO_THE_BONUS_ROUND_WITH_THE_MAIN_ROUND_BET_AMOUNT: 'IF_THE_WHEEL_STOPS_ON_A_GOLDEN_STONE_THE_PLAYER_GETS_A_CHANCE_TO_MOVE_TO_THE_BONUS_ROUND_WITH_THE_MAIN_ROUND_BET_AMOUNT',
  THE_PLAYER_GETS_THE_OPPORTUNITY_TO_PLAY_IN_THE_BONUS_ROUND_UNTIL_THE_NUMBER_OF_SPINS_PROVIDED_IN_THE_FIRST_PART_OF_THE_BONUS_ROUND_EXPIRES: 'THE_PLAYER_GETS_THE_OPPORTUNITY_TO_PLAY_IN_THE_BONUS_ROUND_UNTIL_THE_NUMBER_OF_SPINS_PROVIDED_IN_THE_FIRST_PART_OF_THE_BONUS_ROUND_EXPIRES',
  GAME_RULES_PARAGRAPH_8: 'GAME_RULES_PARAGRAPH_8',

  // infoPopup addresses the rules by these short names; the value is the key the
  // CMS and defaultTranslation actually hold the text under.
  GAME_RULES_PARAGRAPH_1: 'THE_GAME_CONSISTS_OF_THE_BASIC_AND_BONUS_ROUNDS',
  GAME_RULES_PARAGRAPH_2: 'THE_MAIN_SCENE_WHEEL_IS_DIVIDED_INTO_64_SECTORS_EACH_SECTOR_HAS_A_STONE_OF_DIFFERENT_COLORS_THAT_HAVE_FIXED_COEFFICIENTS_IN_PARTICULAR',
  GAME_RULES_PARAGRAPH_3: 'TO_PARTICIPATE_IN_THE_GAME_THE_PLAYER_MUST_CHOOSE_ONE_OF_THE_4_COLORS_OFFERED_IN_THE_GAME_YELLOW_GREEN_RED_BLUE_AND_MAKE_A_PARTICIPATION_FEE_BET_WITHIN_THE_AMOUNT_OFFERED_BY_THE_ORGANIZER_AFTER_MAKING_THE_PAYMENT_AND_PRESSING_THE_SPIN_BUTTON_THE_WHEEL_WILL_START_SPINNING_AND_WILL_STOP_AT_ANY_RANDOM_COLOR_FROM_4_OFFERED_COLORS',
  GAME_RULES_PARAGRAPH_4: 'THE_WINNERS_OF_THE_GAME_WILL_BE_THE_PLAYERS_WHO_CORRECTLY_GUESS_THE_COLOR_THAT_THE_WHEEL_WILL_STOP_ON_FOR_EXAMPLE_IF_THE_PLAYER_HAS_MADE_A_PARTICIPATION_FEE_BY_CHOOSING_THE_COLOR_GREEN_AND_THE_WHEEL_HAS_STOPPED_ON_THE_GREEN_COLOR_IN_THE_GAME_THE_PLAYER_WILL_BE_CONSIDERED_A_WINNER_AND_IF_THE_WHEEL_STOPS_ON_THE_RED_OR_ANY_COLOR_OTHER_THAN_GREEN_OR_GOLD_THE_PLAYERS_BET_WILL_BE_CONSIDERED_LOST',
  GAME_RULES_PARAGRAPH_5: 'THE_PAYOUT_IS_CALCULATED_BY_THE_PLAYERS_PARTICIPATION_FEE_BET_MULTIPLIED_BY_THE_CORRESPONDING_CORRECTLY_PREDICTED_ODDS_AND_IS_TRANSFERRED_TO_THE_PLAYERS_SPECIAL_GAME_ACCOUNT',
  GAME_RULES_PARAGRAPH_6: 'IF_THE_WHEEL_STOPS_ON_A_GOLDEN_STONE_THE_PLAYER_GETS_A_CHANCE_TO_MOVE_TO_THE_BONUS_ROUND_WITH_THE_MAIN_ROUND_BET_AMOUNT',
  GAME_RULES_PARAGRAPH_7: 'THE_PLAYER_GETS_THE_OPPORTUNITY_TO_PLAY_IN_THE_BONUS_ROUND_UNTIL_THE_NUMBER_OF_SPINS_PROVIDED_IN_THE_FIRST_PART_OF_THE_BONUS_ROUND_EXPIRES',
  GAME_RULES_CRYSTAL_DESCRIPTION_BLUE: 'BLUE_30_PIECES_ODDS_X2',
  GAME_RULES_CRYSTAL_DESCRIPTION_RED: 'RED_20_PIECES_ODDS_X3',
  GAME_RULES_CRYSTAL_DESCRIPTION_GREEN: 'GREEN_12_PIECES_ODDS_X5',
  GAME_RULES_CRYSTAL_DESCRIPTION_YELLOW: 'YELLOW_1_PIECES_ODDS_X60',
  GAME_RULES_CRYSTAL_DESCRIPTION_GOLD: 'GOLD_1_ITEM_OPPORTUNITY_TO_PARTICIPATE_IN_THE_BONUS_GAME',

  // Errors
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_SPIN: 'INVALID_SPIN',
  INVALID_AMOUNT: 'INVALID_AMOUNT',
  INVALID_OPERATION: 'INVALID_OPERATION',
  INVALID_SPIN_COUNT: 'INVALID_SPIN_COUNT',
  MONEY_TRANSACTION_ERROR: 'MONEY_TRANSACTION_ERROR',
  NOT_ENOUGH_MONEY: 'NOT_ENOUGH_MONEY',
  NOT_ENOUGH_BALANCE: 'NOT_ENOUGH_BALANCE',
  SPIN_NOT_FOUND: 'SPIN_NOT_FOUND',
  CONNECTION_LOST: 'CONNECTION_LOST',

  // System
  LOADING: 'LOADING',
  SYSTEM_MAINTENANCE: 'SYSTEM_MAINTENANCE',
  WE_ARE_CURRENTLY_OFFLINE_DUE_TO_SERVER_MAINTENANCE_OUR_TEAM_SINCERELY_APOLOGIZES_FOR_THE_INCONVENIENCE_THANK_YOU_FOR_YOUR_PATIENCE: 'WE_ARE_CURRENTLY_OFFLINE_DUE_TO_SERVER_MAINTENANCE_OUR_TEAM_SINCERELY_APOLOGIZES_FOR_THE_INCONVENIENCE_THANK_YOU_FOR_YOUR_PATIENCE',

  // UI
  HOME: 'HOME',
  INFORMATION: 'INFORMATION',
  HOW_TO_PLAY: 'HOW_TO_PLAY',
  GENERAL: 'GENERAL',
  STATISTICS: 'STATISTICS',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  SOUND: 'SOUND',
  ON: 'ON',
  OFF: 'OFF',
  REFRESH: 'REFRESH',
  RELOAD: 'RELOAD',
  TIME: 'TIME',

  // Max payout
  MAX_PAY_OUT_OF_THE_GAME_IS_VALUE: 'MAX_PAY_OUT_OF_THE_GAME_IS_VALUE',
};

export const defaultTranslation = {
  [translationKeys.AUTOSPIN]: 'Autospin',
  [translationKeys.BET]: 'Bet',
  [translationKeys.WIN]: 'Win',
  [translationKeys.BALANCE]: 'Balance',
  [translationKeys.LAST_WIN]: 'Last Win',
  [translationKeys.LAST_RESULTS]: 'Last Results',
  [translationKeys.DEPOSIT]: 'Deposit',
  [translationKeys.PLAY]: 'Play',
  [translationKeys.PLAY_NOW]: 'Play Now',
  [translationKeys.PRESS_TO_START]: 'Press to Start',
  [translationKeys.PRESS_ANYWHERE_TO_CONTINUE]: 'Press anywhere to continue',
  [translationKeys.SPIN]: 'Spin',
  [translationKeys.BONUS]: 'Bonus',
  [translationKeys.BONUS_GAME]: 'Bonus game',
  [translationKeys.BUY_BONUS]: 'Buy Bonus',
  [translationKeys.BUY_BONUS_GAME]: 'Buy Bonus Game',
  [translationKeys.BUY_BONUS_TICKET]: 'Buy Bonus Ticket',
  [translationKeys.PRE_BONUS_GAME]: 'Pre Bonus Game',
  [translationKeys.FREE_SPINS]: 'Free Spins',
  [translationKeys.MULTIPLIER]: 'Multiplier',
  [translationKeys.RESPINS_LEFT]: 'Respins Left',
  [translationKeys.BET_AMOUNT]: 'Bet Amount',
  [translationKeys.BET_TYPE]: 'Bet Type',
  [translationKeys.BET_HISTORY]: 'Bet History',
  [translationKeys.YOUR_BET]: 'Your Bet',
  [translationKeys.YOUR_BET_IS_ACCEPTED]: 'Your bet is accepted',
  [translationKeys.BIG_WIN]: 'Big Win!!',
  [translationKeys.CONGRATULATIONS]: 'Congratulations!',
  [translationKeys.CONGRATULATIONS_YOU_HAVE_WON]: 'Congratulations! You have WON!',
  [translationKeys.YOU_HAVE_WON]: 'You have WON',
  [translationKeys.GOOD_LUCK]: 'Good Luck',
  [translationKeys.WIN_ODDS]: 'Win Odds',
  [translationKeys.CRYSTAL_CRUSH]: 'Crystal Crush',
  [translationKeys.GAME_RULES]: 'Game Rules',
  [translationKeys.GAME_HISTORY]: 'Game History',
  [translationKeys.GAME_HISTORY_TIME]: 'Time',
  [translationKeys.GAME_HISTORY_BET]: 'Bet',
  [translationKeys.GAME_HISTORY_WIN]: 'Win',
  [translationKeys.GAME_HISTORY_WIN_ODD]: 'Win Odds',
  [translationKeys.GAME_HISTORY_BONUS]: 'Bonus',
  [translationKeys.INTRODUCTION_GAME_MAIN_TITLE]: 'Bet Types and Odds',
  [translationKeys.ALL_THE_COLORS_ARE_WINNING]: 'All the colors are winning',
  [translationKeys.YELLOW_1_PIECES_ODDS_X60]: 'Yellow 1 pieces (odds x60)',
  [translationKeys.GREEN_12_PIECES_ODDS_X5]: 'Green 12 pieces (odds x5)',
  [translationKeys.RED_20_PIECES_ODDS_X3]: 'Red 20 pieces (odds x3)',
  [translationKeys.BLUE_30_PIECES_ODDS_X2]: 'Blue 30 pieces (odds x2)',
  [translationKeys.GOLD_1_ITEM_OPPORTUNITY_TO_PARTICIPATE_IN_THE_BONUS_GAME]: 'Gold 1 item (opportunity to participate in the bonus game)',
  [translationKeys.CHOOSE_THE_COLOR_SPIN_THE_WHEEL_AND_MULTIPLY_YOUR_BET_BY_THE_GUESSED_ODDS_GOLD_CRYSTAL_WILL_GUARANTEE_FREE_BONUS_GAME_TICKET_WITH_YOUR_CURRENT_BET]: 'Choose the color spin the wheel and multiply your bet by the guessed odds gold crystal will guarantee free bonus game ticket with your current bet',
  [translationKeys.COLLECT_FREE_SPINS_MULTIPLIERS_AND_CRYSTALS_IN_PRE_BONUS_GAME_TO_RAISE_YOUR_CHANCES_IN_BONUS_GAME]: 'Collect free spins, multipliers and crystals in pre bonus game to raise your chances in bonus game',
  [translationKeys.GOLD_CRYSTAL_WILL_GUARANTEE_FREE_BONUS_GAME_TICKET_WITH_YOUR_CURRENT_BET]: 'Gold crystal will guarantee free bonus game ticket with your current bet',
  [translationKeys.DONT_WAIT_FOR_IT_BUY_IT_YOU_CAN_BUY_A_BONUS_GAME_TICKET_ANYTIME]: 'Don\'t wait for it - BUY IT! You can buy a bonus game ticket anytime!',
  [translationKeys.YOU_CAN_BUY_A_BONUS_GAME_TICKET_ANY_TIME]: 'You can buy a bonus game ticket any time',
  [translationKeys.WATCH_THE_BONUS_GAME_AND_ENJOY_YOUR_TIME]: 'Watch the bonus game and enjoy your time. Max pay out of the game is {{value}}',
  [translationKeys.THE_GAME_CONSISTS_OF_THE_BASIC_AND_BONUS_ROUNDS]: 'The game consists of the basic and bonus rounds',
  [translationKeys.THE_MAIN_SCENE_WHEEL_IS_DIVIDED_INTO_64_SECTORS_EACH_SECTOR_HAS_A_STONE_OF_DIFFERENT_COLORS_THAT_HAVE_FIXED_COEFFICIENTS_IN_PARTICULAR]: 'The main scene wheel is divided into 64 sectors.Each sector has a stone of different colors that have fixed coefficients in particular',
  [translationKeys.TO_PARTICIPATE_IN_THE_GAME_THE_PLAYER_MUST_CHOOSE_ONE_OF_THE_4_COLORS_OFFERED_IN_THE_GAME_YELLOW_GREEN_RED_BLUE_AND_MAKE_A_PARTICIPATION_FEE_BET_WITHIN_THE_AMOUNT_OFFERED_BY_THE_ORGANIZER_AFTER_MAKING_THE_PAYMENT_AND_PRESSING_THE_SPIN_BUTTON_THE_WHEEL_WILL_START_SPINNING_AND_WILL_STOP_AT_ANY_RANDOM_COLOR_FROM_4_OFFERED_COLORS]: 'To participate in the game the player must choose one of the 4 colors offered in the game (yellow, green, red, blue) and make a participation fee (bet) within the amount offered by the organizer. After making the payment and pressing the spin button, the wheel will start spinning and will stop at any random color from 4 offered colors.',
  [translationKeys.THE_WINNERS_OF_THE_GAME_WILL_BE_THE_PLAYERS_WHO_CORRECTLY_GUESS_THE_COLOR_THAT_THE_WHEEL_WILL_STOP_ON_FOR_EXAMPLE_IF_THE_PLAYER_HAS_MADE_A_PARTICIPATION_FEE_BY_CHOOSING_THE_COLOR_GREEN_AND_THE_WHEEL_HAS_STOPPED_ON_THE_GREEN_COLOR_IN_THE_GAME_THE_PLAYER_WILL_BE_CONSIDERED_A_WINNER_AND_IF_THE_WHEEL_STOPS_ON_THE_RED_OR_ANY_COLOR_OTHER_THAN_GREEN_OR_GOLD_THE_PLAYERS_BET_WILL_BE_CONSIDERED_LOST]: 'The winners of the game will be the players who correctly guess the color that the wheel will stop on. For example if the player has made a participation fee by choosing the color green and the wheel has stopped on the green color in the game, the player will be considered as a winner. And if the wheel stops on the red or any color other than green or gold the player\'s bet will be considered lost',
  [translationKeys.THE_PAYOUT_IS_CALCULATED_BY_THE_PLAYERS_PARTICIPATION_FEE_BET_MULTIPLIED_BY_THE_CORRESPONDING_CORRECTLY_PREDICTED_ODDS_AND_IS_TRANSFERRED_TO_THE_PLAYERS_SPECIAL_GAME_ACCOUNT]: 'The payout is calculated by the player\'s participation fee (bet) multiplied by the corresponding correctly predicted odds and is transferred to the player\'s special game account.',
  [translationKeys.IF_THE_WHEEL_STOPS_ON_A_GOLDEN_STONE_THE_PLAYER_GETS_A_CHANCE_TO_MOVE_TO_THE_BONUS_ROUND_WITH_THE_MAIN_ROUND_BET_AMOUNT]: 'If the wheel stops on a golden stone the player gets a chance to move to the bonus round with the main round bet amount.',
  [translationKeys.THE_PLAYER_GETS_THE_OPPORTUNITY_TO_PLAY_IN_THE_BONUS_ROUND_UNTIL_THE_NUMBER_OF_SPINS_PROVIDED_IN_THE_FIRST_PART_OF_THE_BONUS_ROUND_EXPIRES]: 'The player gets the opportunity to play in the bonus round until the number of spins provided in the first part of the bonus round expires.',
  [translationKeys.GAME_RULES_PARAGRAPH_8]: 'Max pay out of the game is {{value}}',
  [translationKeys.INVALID_TOKEN]: 'Invalid token',
  [translationKeys.INVALID_SPIN]: 'Invalid spin',
  [translationKeys.INVALID_AMOUNT]: 'Invalid amount',
  [translationKeys.INVALID_OPERATION]: 'Invalid operation',
  [translationKeys.INVALID_SPIN_COUNT]: 'Invalid spin count',
  [translationKeys.MONEY_TRANSACTION_ERROR]: 'Money transaction error',
  [translationKeys.NOT_ENOUGH_MONEY]: 'Not enough money',
  [translationKeys.NOT_ENOUGH_BALANCE]: 'Not enough balance',
  [translationKeys.SPIN_NOT_FOUND]: 'Spin not found',
  [translationKeys.CONNECTION_LOST]: 'Connection Lost',
  [translationKeys.LOADING]: 'Loading',
  [translationKeys.SYSTEM_MAINTENANCE]: 'System Maintenance',
  [translationKeys.WE_ARE_CURRENTLY_OFFLINE_DUE_TO_SERVER_MAINTENANCE_OUR_TEAM_SINCERELY_APOLOGIZES_FOR_THE_INCONVENIENCE_THANK_YOU_FOR_YOUR_PATIENCE]: 'We are currently offline due to server maintenance. Our team sincerely apologizes for the inconvenience. Thank You for Your patience',
  [translationKeys.HOME]: 'Home',
  [translationKeys.INFORMATION]: 'Information',
  [translationKeys.HOW_TO_PLAY]: 'How to play',
  [translationKeys.GENERAL]: 'General',
  [translationKeys.STATISTICS]: 'Statistics',
  [translationKeys.TERMS_AND_CONDITIONS]: 'Terms and conditions',
  [translationKeys.SOUND]: 'Sound',
  [translationKeys.ON]: 'On',
  [translationKeys.OFF]: 'Off',
  [translationKeys.REFRESH]: 'Refresh',
  [translationKeys.RELOAD]: 'Reload',
  [translationKeys.TIME]: 'Time',
  [translationKeys.MAX_PAY_OUT_OF_THE_GAME_IS_VALUE]: 'MAX_PAY_OUT_OF_THE_GAME_IS_ {{VALUE}}',
};

/**
 * Get translation value from gameDrawer with fallback to defaultTranslation
 * @param {string} key - Translation key from translationKeys
 * @returns {string} Translated value
 */
export const getTranslation = (key) => {
  // Lazy import to avoid circular dependency
  const { gameDrawer } = require('../../game/GameDrawer');
  return gameDrawer.translations?.[key] || defaultTranslation[key] || key;
};